export const vossSubscriptionItemTerminationTiming = {
    AtSubscriptionBillingPeriodEnd: 0,
    AtBindingPeriodEnd: 1,
    Immediately: 2,
    AtScheduledDate: 3
}

export const VossSubscriptionItemTerminationTimingText = {
    [vossSubscriptionItemTerminationTiming.AtSubscriptionBillingPeriodEnd]: "vossSubscriptionItemTerminationTiming.atSubscriptionBillingPeriodEnd",
    [vossSubscriptionItemTerminationTiming.AtBindingPeriodEnd]: "vossSubscriptionItemTerminationTiming.atBindingPeriodEnd",
    [vossSubscriptionItemTerminationTiming.Immediately]: "vossSubscriptionItemTerminationTiming.immediately",
    [vossSubscriptionItemTerminationTiming.AtScheduledDate]: "vossSubscriptionItemTerminationTiming.atScheduledDate"
}